import React, { useEffect, useMemo } from "react";
import Input from "@/app/components/ui/Inputs/Input";
import { PRIMARY_BUTTON } from "@/constants";
import NonSearchableSelectMenu from "@/app/components/ui/SelectMenus/NonSearchableSelectMenu";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useForm } from "react-hook-form";
import { useVoucherCategorySubCategoryAPI } from "@/app/hooks/api_hooks/Membership/useVoucherCategorySubCategoryAPI";
import { getVoucherSubCategoryItems, mapVoucherCategorySubCategory } from "../utils";
import { useMembershipVoucherCreationAPI } from "@/app/hooks/api_hooks/Membership/useMembershipVoucherCreationAPI";
import { useNavigate } from "react-router";

const MembershipVoucherCreation = () => {


  const { execute: fetchCategorySubCategory, categorySubCategory } = useVoucherCategorySubCategoryAPI();

  const {execute:voucherOnbord }=useMembershipVoucherCreationAPI()
  
  const navigate = useNavigate();

  const formHook = useForm({
    defaultValues: {
      voucher_name: "",
      type: "",
      category: "",
      sub_category: "",
      value: "",
      category_name:"",
      category_id:"",
      sub_category_name:"",
      sub_category_id:"",
      Type:"",
      servicetype:""

    },
  });

  useEffect(() => {
    fetchCategorySubCategory();
  }, []);

  const categorySubCategoryMap = useMemo(
    () => mapVoucherCategorySubCategory(categorySubCategory),
    [categorySubCategory],
  );

  const selectedCategoryId = formHook.watch("category_id");
  const voucherCategoryItem = categorySubCategoryMap.categorySelectItems;
  const voucherSubCategoryItem = useMemo(
    () => getVoucherSubCategoryItems(categorySubCategoryMap, selectedCategoryId),
    [categorySubCategoryMap, selectedCategoryId],
  );

  const typeOptions = [
    { id: "1", title: "VACCINE" },
    { id: "2", title: "BATH" },
    { id: "3", title: "HAIR_CUT" },
    { id: "4", title: "FULL_GROOMING" },
    { id: "5", title: "DEWORMING"},
    { id: "6", title: "SWIMMING"},
    { id: "7", title: "PHYSIOTHERAPY"},
    { id: "8", title: "HYGIENE"},
    { id:"9",title:"SURGERY"},
    { id:"10",title:"CONSULTATION"},
    { id:"11",title:"XRAY_VIEW"},
    { id:"12",title:"ULTRASOUND_MULTI_ORGAN"},
    { id:"13",title:"ULTRASOUND_SINGLE_ORGAN"}
  ];

  const serviceTypeOptions = [
    { id: "1", title: "BOM" },
    { id: "2", title: "SERVICE" },
    
    ];

  const onSubmit = (data: any) => {
console.log(data,"Dsjh")
    const constructedBody={
      name: data.voucher_name,
      type: data.type,
      value: parseInt(data.value),
      tax_details: {
        hsn_code: "0",
        cgst:0,
        sgst: 0,
        igst: 0,
        utgst:0,
      },
      category_id: data.category_id,
      category_name: data.category_name,
      sub_category_id: data.sub_category_id,
      sub_category_name: data.sub_category_name,
      service_type: data.servicetype,
      is_active: true,
    }
    
    voucherOnbord(constructedBody).then((res)=>{   
      if(res.status){
        navigate(`/app/voucher-setup/voucher-list`)
      } 

     })
    
  };



  return (
    <div className="p-6 w-full">
      <p className="text-lg font-semibold mb-4">Voucher setup</p>
      <form
       onSubmit={formHook.handleSubmit(onSubmit, (e) => console.log(e))}
        className="space-y-6 bg-white shadow p-6 rounded-lg"
      >
        {/* Voucher Name */}
        <div className="w-6/12">
          <label className="block text-sm font-medium mb-1">
            Voucher Name <span className="text-red-500">*</span>
          </label>
          <Input
            className="text-xs"
            placeholder="Enter voucher name"
            register={formHook.register("voucher_name", {
              required: true,
              validate: (value) =>
                value.trim() !== "" || "Name cannot be empty or only spaces",
            })}
            fieldError={formHook.formState.errors.voucher_name}
            errorMessages={[
              { message: "Name is required", type: "required" },
              { message: "Name cannot be empty or only spaces", type: "validate" },
            ]}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              formHook.setValue("voucher_name", e.target.value);
              formHook.clearErrors("voucher_name");
            }}
          />
        </div>

        {/* Type */}
        <div className="w-6/12">
          <label className="block text-sm font-medium mb-1">
            Type <span className="text-red-500">*</span>
          </label>
          <NonSearchableSelectMenu
            errorMessages={[{ message: "Type is required", type: "required" }]}
            onSelectItem={(item) => {
              if (item) formHook.setValue("type", item.title);
            }}
            fieldError={formHook.formState.errors.type}
            register={formHook.register("type", { required: true })}
            selectItems={typeOptions}
            placeholder="Select Type"
            showTooltips={false}
            showTypedErrors={true}
            showDropdownIcon={true}
            defaultSelected={typeOptions.find(
              (opt) => opt.title === formHook.watch("type")
            )}
            listBoxClassName="w-full"
            className="text-gray-800"
            containerClassName="w-full"
          />
        </div>

        {/* Service Type */}
       
        <div className="w-6/12">
          <label className="block text-sm font-medium mb-1">
            Service Type<span className="text-red-500">*</span>
          </label>
          <NonSearchableSelectMenu
            errorMessages={[{ message: "ServiceType is required", type: "required" }]}
            onSelectItem={(item) => {
              if (item) formHook.setValue("servicetype", item.title);
            }}
            fieldError={formHook.formState.errors.servicetype}
            register={formHook.register("servicetype", { required: true })}
            selectItems={serviceTypeOptions}
            placeholder="Select Service Type"
            showTooltips={false}
            showTypedErrors={true}
            showDropdownIcon={true}
            defaultSelected={serviceTypeOptions.find(
              (opt) => opt.title === formHook.watch("servicetype")
            )}
            listBoxClassName="w-full"
            className="text-gray-800"
            containerClassName="w-full"
          />
        </div>

        {/* Category */}
        <div className="w-6/12">
          <label className="block text-sm font-medium mb-1">
            Category <span className="text-red-500">*</span>
          </label>
          <SearchableSelectMenu
            errorMessages={[{ message: "Category is required", type: "required" }]}
            onSelectItem={(item) => {
              if (item){
                 formHook.setValue("category_id", item.id)
                 formHook.setValue("category_name", item.title)
                 formHook.setValue("sub_category_id", "")
                 formHook.setValue("sub_category_name", "")
                }
            }}
            fieldError={formHook.formState.errors.category_id}
            register={formHook.register("category_id", { required: true })}
            selectItems={voucherCategoryItem}
            placeholder="Select Category"
            showTooltips={false}
            showTypedErrors={true}
            showDropdownIcon={true}
            defaultSelected={voucherCategoryItem.find(
              (opt) => opt.id === formHook.watch("category_id")
            )}
            listBoxClassName="w-full"
            className="text-gray-800"
            containerClassName="w-full"
          />
        </div>

        {/* Sub Category */}
        <div className="w-6/12">
          <label className="block text-sm font-medium mb-1">
            Sub Category <span className="text-red-500">*</span>
          </label>
          <SearchableSelectMenu
            key={selectedCategoryId}
            errorMessages={[
              { message: "Sub Category is required", type: "required" },
            ]}
            onSelectItem={(item) => {
             if (item){
                 formHook.setValue("sub_category_id", item.id)
                 formHook.setValue("sub_category_name", item.title)
                }
            }}
            fieldError={formHook.formState.errors.sub_category_id}
            register={formHook.register("sub_category_id", { required: true })}
            selectItems={voucherSubCategoryItem}
            placeholder="Select Sub Category"
            showTooltips={false}
            showTypedErrors={true}
            showDropdownIcon={true}
            defaultSelected={voucherSubCategoryItem.find(
              (opt) => opt.id === formHook.watch("sub_category_id")
            )}
            listBoxClassName="w-full"
            className="text-gray-800"
            containerClassName="w-full"
          />
        </div>

        {/* Value */}
        <div className="w-6/12">
          <label className="block text-sm font-medium mb-1">
            Value <span className="text-red-500">*</span>
          </label>
          <Input
            type="number"
            placeholder="Enter value"
            register={formHook.register("value", { required: true })}
            fieldError={formHook.formState.errors.value}
            errorMessages={[{ message: "Value is required", type: "required" }]}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              formHook.setValue("value", e.target.value);
              formHook.clearErrors("value");
            }}
          />
        </div>

        

        <button type="submit" className={`${PRIMARY_BUTTON} mt-6`}>
          Create Voucher
        </button>
      </form>
    </div>
  );
};

export default MembershipVoucherCreation;


